/** saves Accounts Balances
@payload { Array } https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accountsbalances
*/
export const SAVE_ACCOUNTS_BALANCE = (state, payload) => {
    state.accountsBalances = payload.balanceViews
}

/** saves accounts with operations pending signature
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationssignedaccounts
*/
export const SAVE_ACCOUNTS_WITH_OPERATIONS_PENDING_SIGNATURE = (state, payload) => {
    state.accountsWithOperationsPendingSignature = payload.accounts
}

/** saves the operation details
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationsdetails_
*/
export const SAVE_OPERATION_DETAILS = (state, payload) => {
    state.operationDetails = payload.lineGroups
}

/** saves accounts list
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_accounts
*/
export const SAVE_ACCOUNTS_LIST = (state, payload) => {
    state.accountsList = payload
}

/** saves profiles list
@payload { array }
*/
export const SAVE_PROFILES_LIST = (state, payload) => {
    state.profilesList = payload.operatorProfileViewList
}

/** saves operator details - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operators%7Bid%7D
@payload { object }
*/
export const SAVE_OPERATOR_DETAILS = (state, payload) => {
    state.operatorDetails = payload
}

/** saves operations type
@payload { array } - https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationstypes
*/
export const SAVE_OPERATIONS_TYPES = (state, payload) => {
    state.operationsTypesList = payload
}